import React from "react";
import {createStyles, makeStyles, StyledComponentProps, Theme} from "@material-ui/core";

interface ReactProps {
    children: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    addContainer: {
        padding: theme.spacing(2),
        textAlign: "right"
    }
}));

type IProps = ReactProps & StyledComponentProps;

const AddContainer:React.FC<IProps> = (props:IProps) => {
    const classes = useStyles();
    return (
        <div className={classes.addContainer}>
            {props.children}
        </div>
    );
};

export default AddContainer;